export const CHANGE_PIN_START = 'CHANGE_PIN_START';
export const CHANGE_PIN_END = 'CHANGE_PIN_END';
export const CHANGE_PIN_SUCCESS = 'CHANGE_PIN_SUCCESS';
export const CHANGE_PIN_FAIL = 'CHANGE_PIN_FAIL';
export const CHANGE_PIN_CLEAR = 'CHANGE_PIN_CLEAR';
